import { Outlet } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { DesktopShell } from "./DesktopShell";
import { MobileShell } from "./MobileShell";
import { MobileShellV2 } from "./MobileShellV2";
import { useUiVersionStore } from "@/store/ui-version-store";

export function AppLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  // V2 currently only applies to mobile — the desktop side-rail layout
  // is untouched. If we ever ship a V2 desktop variant it'd slot in
  // with its own conditional here.
  const uiVersion = useUiVersionStore((s) => s.uiVersion);

  const content = <Outlet />;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      {isDesktop
        ? <DesktopShell>{content}</DesktopShell>
        : uiVersion === "v2"
          ? <MobileShellV2>{content}</MobileShellV2>
          : <MobileShell>{content}</MobileShell>}
    </Box>
  );
}
